<template>
  <div v-loading="loading" class="main-frame">
    <el-container>
      <el-header class="banner-head">
        <div class="head-info">
          <el-row>
            <el-col style="text-align: left" :span="12">
              <el-page-header
                title="返回"
                @back="goBack"
                content="横幅宽高比详情"
              ></el-page-header>
            </el-col>
            <el-col style="text-align: right" :span="12">
              <el-button
                type="primary"
                icon="el-icon-check"
                @click="saveModelOnclick"
                >保存</el-button
              >
            </el-col>
          </el-row>
        </div>
      </el-header>
      <el-main>
        <el-form
          class="type-form"
          :model="edit_model"
          ref="modelForm"
          label-width="auto"
        >
          <el-form-item label="宽高比:">
            <el-input :value="calculatedAspectRatio" disabled></el-input>
          </el-form-item>
          <el-form-item label="平台:">
            <el-select
              v-model="edit_model.platform"
              placeholder="请选择"
              loading-text="加载中"
            >
              <el-option
                v-for="item in platform_list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select
              v-model="edit_model.status"
              placeholder="请选择"
              loading-text="加载中"
            >
              <el-option
                v-for="item in $common.StatusSelectList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="宽:">
            <el-input-number
              :min="1"
              v-model="edit_model.width"
              clearable
            ></el-input-number>
          </el-form-item>
          <el-form-item label="高:">
            <el-input-number
              :min="1"
              v-model="edit_model.height"
              clearable
            ></el-input-number>
          </el-form-item>
          <el-form-item label="权重:">
            <el-input-number
              v-model="edit_model.number"
              :min="0"
              label="权重"
            ></el-input-number>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { GetCacheKey } from "@/const";

export default {
  name: "BannerAspectRatioDetailView",
  components: {},
  data() {
    return {
      loading: false,
      edit_model_id: "",
      edit_model: {
        id: "",
        aspect_ratio_key: "",
        width: "",
        height: "",
        platform: 1,
        number: "",
        status: 1,
      },
      platform_list: [
        {
          id: 1,
          name: "PC",
        },
        {
          id: 2,
          name: "WAP",
        },
      ],
      cacheKey: GetCacheKey("banner"),
    };
  },
  created() {
    this.edit_model_id = this.$route.query.id;
    if (this.edit_model_id !== undefined && this.edit_model_id.length > 0) {
      // 编辑
      this.getEditModel();
    }
  },
  computed: {
    calculatedAspectRatio() {
      if (this.edit_model.width && this.edit_model.height) {
        // 计算最大公约数
        const gcd = (a, b) => (b ? gcd(b, a % b) : a);
        const width = parseInt(this.edit_model.width);
        const height = parseInt(this.edit_model.height);
        if (width && height) {
          const divisor = gcd(width, height);
          return `${width / divisor}/${height / divisor}`;
        }
      }
      return "";
    },
  },
  watch: {
    calculatedAspectRatio(newVal) {
      this.edit_model.aspect_ratio_key = newVal;
    },
  },
  methods: {
    getEditModel() {
      let _me = this;
      _me.loading = true;
      let params = {
        id: _me.edit_model_id,
      };
      _me.$common
        .httpPost("/api/banner/admin/aspect_ratio/find/id", params)
        .then((res) => {
          _me.loading = false;
          if (res.code === "1000000") {
            _me.edit_model = res.data;
          } else {
            _me.$message({
              message: res.message || "获取数据失败",
              type: "error",
            });
          }
        })
        .catch((err) => {
          _me.loading = false;
          _me.$message({
            message: err || "获取数据失败",
            type: "error",
          });
        });
    },
    saveModelOnclick() {
      let _me = this;
      _me.$refs["modelForm"].validate((valid) => {
        if (valid) {
          if (_me.edit_model_id !== undefined && _me.edit_model_id.length > 0) {
            _me.updateOneModel();
          } else {
            _me.addNewModel();
          }
        } else {
          _me.$message({
            message: "请检查表单!",
            type: "error",
          });
        }
      });
    },
    addNewModel() {
      let _me = this;
      let params = {
        aspect_ratio_key: _me.edit_model.aspect_ratio_key,
        width: _me.edit_model.width,
        height: _me.edit_model.height,
        platform: _me.edit_model.platform,
        number: _me.edit_model.number,
        status: _me.edit_model.status,
      };
      _me.loading = true;
      _me.$common
        .httpPost("/api/banner/admin/aspect_ratio/add", params)
        .then((res) => {
          _me.loading = false;
          if (res.code === "1000000") {
            _me.$message.success("内容添加成功");
            this.$common.removeGlobalStorage(this.cacheKey.aspectRatioList);
            _me.goBack();
          } else {
            _me.$message({
              message: res.message || "获取数据失败",
              type: "error",
            });
          }
        })
        .catch((err) => {
          _me.loading = false;
          _me.$message({
            message: err || "获取数据失败",
            type: "error",
          });
        });
    },
    updateOneModel() {
      let _me = this;
      let params = {
        id: _me.edit_model.id,
        aspect_ratio_key: _me.edit_model.aspect_ratio_key,
        width: _me.edit_model.width,
        height: _me.edit_model.height,
        platform: _me.edit_model.platform,
        number: _me.edit_model.number,
        status: _me.edit_model.status,
      };
      _me.loading = true;
      _me.$common
        .httpPost("/api/banner/admin/aspect_ratio/update", params)
        .then((res) => {
          _me.loading = false;
          if (res.code === "1000000") {
            _me.$message.success("内容保存成功");
            this.$common.removeGlobalStorage(this.cacheKey.aspectRatioList);
            _me.goBack();
          } else {
            _me.$message({
              message: res.message || "获取数据失败",
              type: "error",
            });
          }
        })
        .catch((err) => {
          _me.loading = false;
          _me.$message({
            message: err || "获取数据失败",
            type: "error",
          });
        });
    },
    goBack() {
      // 返回上一级路由
      this.$router.go(-1);
    },
    // 复制信息
    copyInfo(str) {
      // 触发赋值事件，将当前的数据传值
      this.$refs.copyPaste.CopyInfo(str);
    },
    // 粘贴信息
    pasteInfo(model) {
      // 接受粘贴事件的传值数据
      this.edit_model = model;
      this.edit_model.id = this.edit_model_id;
    },
  },
};
</script>

<style scoped></style>
